import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { approverGridColumns } from "../utilis/approverGridColumns";
import { load_approver_data_from_backend } from "../utilis/approverServices";
import { useGridApiRef } from "@mui/x-data-grid-pro";

const ApproverTabContent = ({ tabName }) => {
    const [data, setData] = useState([]);
    const columnsData = Object.values(approverGridColumns);
    const apiRef = useGridApiRef();
    useEffect(() => {
        // load_approver_data_from_backend(data, setData, tabName);
        // Function to load data
        const loadData = () => {
            load_approver_data_from_backend(data, setData, tabName);
        };

        // Load data initially
        loadData();

        // Set up the interval to load data every 20 seconds
        const intervalId = setInterval(loadData, 20000);

        // Clean up the interval on unmount
        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    // console.log(data);
    return (
        <>
            {
                data && <CustomDataGrid
                    // processRowUpdate={async (updatedRow, originalRow) => {
                    //     const result = await edit_sample_receiver_schedule(updatedRow, tabName);
                    //     if (result) return updatedRow;
                    //     else return originalRow;
                    // }
                    // }
                    apiRef={apiRef}
                    columns={columnsData}
                    rows={data || []}
                    initialState={{
                        pinnedColumns: {
                            right: ["approval"]
                        }
                    }}
                    columnVisibilityModel={{
                        id: false,
                        data_shared_on: false,
                        pack: false,
                        "condition_/_stage": false,
                        other_test: false,
                        "no._of_days_left_for_completion_of_analysis": false,
                        "targeted_date_for_completion_of_analysis": false,
                        "remarks": false,
                        "completed_within__(in_days)": false,
                        "age": false,
                        "s.no.": false,
                    }}
                    sx={{
                        height: "700px"
                    }}
                />
            }


        </>
    );
};
export default ApproverTabContent;